import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { UserListComponent } from './user-list/user-list.component';
import { UserRoutingModule } from './user.routing';
@NgModule({
        imports : [BrowserModule, UserRoutingModule],
        declarations : [UserListComponent]
})

export class UserModule {}




// WEBPACK FOOTER //
// /home/xpro/Documentos/ances/myjangular/src/app/users/user.module.ts